import React from "react";
import Ajax from "../Ajax";
import { Button, LinearProgress } from '@mui/material';


export default class ErrorBoundary extends React.Component {

    constructor(props) {

        super(props)

        this.state = {
            hasError: false,
            error: "",
            errorInfo: null
        }
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error: error }
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        this.setState({errorInfo: errorInfo})
        this.writeLogToServer(`Frontend error: ${error.toString()}\n${errorInfo?.componentStack}`)
    }

    writeLogToServer (message) {
        Ajax.Session.Log(message)
    }

    render () {

        if (!this.state.hasError) {
            return <>{this.props.children}</>
        }

        return (
            <div className="error-boundary">
                <h3>Front end error</h3>

                <p>{this.state.error.toString()}</p>

                <p className="code">{this.state.errorInfo?.componentStack}</p>

                <Button className="btn btn-lg" variant="contained" color="success" onClick={() => window.location.reload()}>Reset App</Button>
            </div>
        )
    }
  }